import type { Trigger } from './types';

export const immediately: Trigger = (triggerName = 'immediately') => {
  return (activate) => activate(triggerName);
};
